import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Ghost } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/compte");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="register-page">
      <div className="text-center mb-8">
        <Ghost className="h-10 w-10 text-amber-500 mx-auto mb-3" />
        <h1 className="font-display text-3xl font-black text-stone-100">Créer un compte</h1>
        <p className="text-stone-400 text-sm mt-2">Suivez vos commandes et gagnez du temps au paiement.</p>
      </div>
      <form onSubmit={submit} className="gothic-card rounded-2xl p-8 space-y-5">
        {error && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-3" data-testid="register-error">{error}</p>}
        <div>
          <label className="block text-sm text-stone-400 mb-2">Nom</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name"
            className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
        </div>
        <div>
          <label className="block text-sm text-stone-400 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email"
            className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
        </div>
        <div>
          <label className="block text-sm text-stone-400 mb-2">Mot de passe (min. 6 caractères)</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password"
            className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
        </div>
        <button type="submit" disabled={loading} data-testid="register-submit" className="btn-ember rounded-xl w-full py-3.5 disabled:opacity-60">
          {loading ? "Création…" : "Créer mon compte"}
        </button>
        <p className="text-center text-sm text-stone-400">
          Déjà inscrit ? <Link to="/connexion" className="text-amber-400 hover:underline">Se connecter</Link>
        </p>
      </form>
    </div>
  );
}
